import { DelaysManagerPage } from "./DelaysManagerPage";

type Props = {};
const DelaysManager = (props: Props) => {
	return <DelaysManagerPage />;
};
export default DelaysManager;
